import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { ClientErrorBoundary } from "./components/client-error-boundary";
import { router } from "./router";
import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#root");

if (!root) {
  throw new Error("Application root was not found.");
}

createRoot(root).render(
  <StrictMode>
    <ClientErrorBoundary>
      <RouterProvider router={router} />
    </ClientErrorBoundary>
  </StrictMode>,
);
